// lib/ads/frequencyCap.ts
// Optional, per-browser frequency capping for ad slots (localStorage).
// Disabled by default (capHours <= 0) so paid impressions are never silently
// dropped — opt in per slot via the SponsoredSlot `frequencyCapHours` prop.

const PREFIX = 'smt-ad-seen:';

/** True if the slot may be shown for this key now. */
export function shouldShow(key: string, capHours: number): boolean {
  if (!capHours || capHours <= 0) return true;
  if (typeof window === 'undefined') return true;
  try {
    const last = Number(window.localStorage.getItem(PREFIX + key) || 0);
    if (!last) return true;
    return Date.now() - last >= capHours * 3600 * 1000;
  } catch {
    return true;
  }
}

/** Record that the slot was shown (starts the cap window). */
export function recordShown(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PREFIX + key, String(Date.now()));
  } catch {
    /* storage unavailable — best effort */
  }
}
